import { useCallback, useState } from 'react';

import { PageTitles } from '@revelio/core';

import DashboardPage from '../DashboardPage';
import { ReportsTable } from './reports-table/reports-table';

const ReportsPage = () => {
  const [loading, setIsLoading] = useState<boolean>(true);

  const onReportsTableInitialize = useCallback(() => {
    setIsLoading(false);
  }, []);

  const title = [PageTitles.REPORTS_STATUS];

  return (
    <DashboardPage title={title} loading={loading}>
      <ReportsTable onInitialized={onReportsTableInitialize} />
    </DashboardPage>
  );
};

export default ReportsPage;
